import 'css-chunksrc/client/scenes/zoneEdition/styles.scss';export default {
  "main": "_main_1jn2v_1",
  "buttons": "_buttons_1jn2v_8"
};